module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    style: ({
      backgroundColor: _vm.styles.general.background_color
    })
  }, [_c('v-layout', [_c('v-tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "header",
    staticStyle: {
      "background-color": "rgb(245, 245, 245)"
    }
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab,
      attrs: {
        "href": '#' + tab.toLowerCase().replace(/\,|\.|\s/g, ''),
        "ripple": ""
      }
    }, [_vm._v("\n          " + _vm._s(tab) + "\n        ")])
  }), _vm._v(" "), _c('v-tabs-slider', {
    staticClass: "yellow"
  })], 2), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "companyinfo"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('company-info', {
    attrs: {
      "mode": 'view'
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50c30d1d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CompanyView.vue
// module id = 1682
// module chunks = 15